import React from "react";

const NotAuthenticated = () => {
  return <div>NotAuthenticated</div>;
};

export default NotAuthenticated;
